import { AuthFormLocation, AuthFormStep, ErrorMessage } from '../enums';

export type AuthFormState = {
  step: AuthFormStep;
};

export interface AuthFormStepContext {
  from: AuthFormStep;
  to: AuthFormStep;
}

export type LoginRequestObject = {
  username: string;
  password: string;
  keepSignedIn: boolean;
  reloadOnSuccess?: boolean;
  location?: AuthFormLocation;
};

export type LoginState = {
  success: boolean;
  loading: boolean;
  error: ErrorMessage;
};

export type LoginReturnGuestPayload = {
  username: string;
  orderNumber: string;
};

export type SocialMediaProfile = {
  email: string;
  externalId: string;
  imageLink: string;
  name: string;
  type: string;
};

export type SocialMediaProfileLogin = SocialMediaProfile & {
  firstname: string;
  lastname: string;
  gender: string;
  token: string;
};

export type SocialMediaProfileConnection = SocialMediaProfile & {
  customerIdentityId: string;
};
